module.exports = "<svg height=\"10\" width=\"10\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\"><path fill-rule=\"evenodd\" d=\"M9.65 1.9L6.57 4.99l3.08 3.08c.44.43.44 1.14 0 1.58-.44.44-1.15.44-1.59 0L4.99 6.58 1.93 9.65c-.44.44-1.15.44-1.58 0a1.11 1.11 0 0 1 0-1.58L3.41 5 .31 1.9C-.12 1.46-.12.75.31.31c.44-.43 1.15-.43 1.59 0l3.09 3.1L8.07.31c.44-.43 1.15-.43 1.58 0 .44.44.44 1.15 0 1.59z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/close.svg
// module id = 876
// module chunks = 0